export class EventLight {
    id?: string;
    pictureAccessLink?: string;
}
